var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"二手车","name":"first"}},[_c('intranet-goods-list',{ref:"clue-management",attrs:{"businessId":_vm.businessId,"type":"二手车"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }